import type { ReactNode } from 'react';
import { Icon } from './Icon';

interface EmptyStateProps {
  title: string;
  children: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ title, children, action }: EmptyStateProps) {
  return (
    <section className="empty-state">
      <div className="empty-state__icon"><Icon name="map-pin" /></div>
      <h2>{title}</h2>
      <p>{children}</p>
      {action}
    </section>
  );
}
